import AdaptiveQuizIndividual from './AdaptiveQuizIndividual';

export default AdaptiveQuizIndividual;
